(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((menu) => {
      const parentLink = menu.querySelector('.sm-mega-parent-link');
      const summary = menu.querySelector(':scope > summary');
      let closeTimer;

      parentLink?.addEventListener('click', (event) => event.stopPropagation());

      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;

        clearTimeout(closeTimer);

        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((other) => {
          if (other !== menu) {
            other.removeAttribute('open');
            other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
          }
        });

        menu.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;

        clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {
          if (menu.matches(':hover')) return;

          menu.removeAttribute('open');
          summary?.setAttribute('aria-expanded', 'false');
        }, 600);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
